export default __webpack_public_path__ + "static/media/IntrestExl.87c99e86.xlsx";